<template>
  <VFooter
    height="300"
    color="secondary"
  >
    <VLayout wrap>
      <VFlex
        xs12
        class="mb-4 text-xs-center"
      >
        <a
          href="https://www.facebook.com/instaxemlekek"
          target="_blank"
        >
          <img
            src="@/assets/facebook-logo.svg"
            class="logo mr-1"
            alt="Facebook logó"
          >
        </a>

        <a
          href="https://www.instagram.com/_cheese.hu_"
          target="_blank"
        >
          <img
            src="@/assets/instagram-logo.svg"
            class="logo ml-1"
            alt="Instagram logó"
          >
        </a>
      </VFlex>

      <VFlex
        xs12
        class="links mb-4 px-2"
      >
        <router-link :to="'/#kapcsolat'">
          Kapcsolat
        </router-link>
        //
        <router-link :to="{ name: 'PrivacyStatement' }">
          Adatvédelmi nyilatkozat
        </router-link>
        //
        <router-link :to="{ name: 'LegalNotice' }">
          Jogi nyilatkozat
        </router-link>
      </VFlex>

      <VFlex
        xs12
        class="links"
      >
        @ 2019 Cheese.hu
      </VFlex>
    </VLayout>
  </VFooter>
</template>

<script>
export default {
  name: 'ThePageFooter',
};
</script>

<style scoped>
a {
  color: white;
  text-transform: uppercase;
  text-decoration: none;
}

.router-link-active {
  color: white !important;
}

.logo {
  width: 55px;
}

.links {
  color: white;
  font-weight: bold;
  text-align: center;
}
</style>
